import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f882a7f6558f001441795b/prakritiveer/src/app/components/CentreStatusTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f882a7f6558f001441795b/prakritiveer/src/app/components/DashboardCharts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f882a7f6558f001441795b/prakritiveer/src/app/components/DashboardHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f882a7f6558f001441795b/prakritiveer/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69f882a7f6558f001441795b/prakritiveer/src/components/ui/AppIcon.tsx");
